import React, { Component } from "react";
import { reactRouterBaseRoute } from "./config";
import { BrowserRouter, Switch, Route, Redirect } from "react-router-dom";
import { connect } from "react-redux";
import App from "./App";
import Login from "./components/pages/login/Login";
import AuthSession from "./components/pages/login/AuthSession";
import View from "./components/pages/view/View";

class Authentication extends Component {
  render() {
    const PrivateRoute = ({ component: Component, ...rest }) => {
      return (
      <Route
        {...rest}
        render={props => this.props.isLoggedIn ?  <Component {...props} /> :
          // TODO: location.hash become part of location.pathname after redirect.  See HelpDialog.js.
          <Redirect to={{
              pathname: "/auth",
              state: {
                destination: `${window.location.pathname}${window.location.search}${window.location.hash}`
            }}}
          />
        }
      />
    );
      }

    return (
      <BrowserRouter basename={reactRouterBaseRoute}>
        <Switch>
          <Route path="/view/item/:shareHash" render={props => <View {...props} />} />
          <Route path="/view/avatar/:botName" render={props => <View {...props} />} />
          <Route path="/login" render={props => <Login {...props} />} />
          <Route path="/activate/:token" render={props => <Login {...props} />} />
          <Route path="/signup" render={props => <Login {...props} />} />
          <Route path="/auth" render={props => <AuthSession {...props} />} />
          <PrivateRoute component={App} />
        </Switch>
      </BrowserRouter>
    );
  }
}

const mapStateToProps = state => ({ isLoggedIn: state.auth.uid });

// connect react component to the redux store
export default connect(mapStateToProps)(Authentication);
